import { useState } from "react";
import { ProductProps } from "../app/index";
import { CheckoutType } from "../app/types/checkoutType";
import { useUserStore } from "../stores/userStore";
import { useCheckoutStore } from "../stores/checkoutStore";
import { useCreateOrder } from "./useOrder";

export const useCheckout = () => {
  // Usa Zustand per lo stato del checkout
  const { checkout, setCheckout, updateCheckout } = useCheckoutStore();
  const { user } = useUserStore();
  
  // Usa React Query per la gestione dell'ordine
  const createOrderMutation = useCreateOrder();
  
  // Stato locale per il processing (potrebbe essere rimosso in futuro)
  const [processing, setProcessing] = useState(0);

  const setCheckoutProduct = (prodotto: ProductProps) => {
    updateCheckout({ prodotto });
  };

  const confirmCheckout = async (values: any) => {
    try {
      // Processing order
      setProcessing(1);

      // Setup order con dati utente
      const newCheckout: CheckoutType = { 
        ...checkout, 
        ...values,
        provincia: values.provincia?.toUpperCase() || checkout.provincia,
        citta: values.citta?.toUpperCase() || checkout.citta,
        d: user?.d || "",
        idutente_finale: user?.userId || "",
        email: user?.email || "",
        nome: user?.firstName || "",
        cognome: user?.lastName || ""
      };

      // Validazione campi obbligatori
      if (!newCheckout.email || !newCheckout.nome || !newCheckout.cognome) {
        throw new Error("Nome, cognome, email sono informazioni obbligatorie");
      }

      // Aggiorna checkout con i nuovi dati
      updateCheckout(newCheckout);

      // Invia ordine usando React Query
      const receipt = await createOrderMutation.mutateAsync(newCheckout);
      
      // Aggiorna checkout con la risposta
      updateCheckout({ receipt });

      // End processing order
      setProcessing(2);
      
      return receipt;
    } catch (error: any) {
      // Gestione errori migliorata
      let errorMessage = "Errore di connessione, rieffettuare l'accesso";
      
      if (error.message?.includes("420") || error.message?.includes("ERR_BAD_REQUEST Request failed with status code 420")) {
        errorMessage = "Impossibile inviare l'ordine, controlla il tuo credito sul portale Wellwork";
      } else if (error.message?.includes("Network Error") || error.message?.includes("ERR_NETWORK")) {
        errorMessage = "Errore di connessione. Verifica la tua connessione internet e riprova.";
      } else if (error.message?.includes("timeout") || error.message?.includes("ERR_TIMEOUT")) {
        errorMessage = "La richiesta ha impiegato troppo tempo. Riprova tra qualche istante.";
      } else if (error.message?.includes("401") || error.message?.includes("403")) {
        errorMessage = "Sessione scaduta. Effettua nuovamente l'accesso.";
      } else if (error.message?.includes("500")) {
        errorMessage = "Errore del server. Riprova più tardi o contatta il supporto.";
      }
      
      updateCheckout({
        error: { 
          status: "error", 
          message: errorMessage
        },
      });
      setProcessing(2);
      throw error;
    }
  };
  
  return {
    checkout,
    user,
    setCheckoutProduct,
    confirmCheckout,
    processing,
    // Esponi stati di React Query per una migliore UX
    isProcessing: createOrderMutation.isPending,
    error: createOrderMutation.error,
    isSuccess: createOrderMutation.isSuccess
  };
};
